import cn from 'classnames';
import styles from './menu.module.scss';

interface IMenuDividerProps {
  className?: string,
}

const MenuDivider = ({ className }: IMenuDividerProps) => (
  <hr className={ cn(styles.divider, className) } />
);

export default MenuDivider;
